import { IsArray, IsNotEmpty, IsOptional } from 'class-validator';
import { UpsertDiscountDto } from '../../../../models/dto/discount.dto';

export class SetEventDiscountDto extends UpsertDiscountDto {
	/* @description Discount is for all prices if eventPriceIds is empty */
	@IsOptional()
	@IsNotEmpty()
	@IsArray()
	public eventPriceIds?: Array<string>;
}
